import React from "react";
import PropTypes from "prop-types";
import { getLovablePhaseCode } from "../lovablePhaseLabels";
import "./index.css";

/**
 * Wraps an LCA flow block with the large side label (A1, A2, …) matching Lovable.
 */
const LovablePhaseSection = ({ id, phaseCode, className = "", children }) => {
  const code = phaseCode ?? (id ? getLovablePhaseCode(id) : null);

  return (
    <div
      id={id}
      className={["lovable-phase-section", className].filter(Boolean).join(" ")}
    >
      {code ? (
        <div className="lovable-phase-side-label" aria-hidden="true">
          {code}
        </div>
      ) : null}
      {children}
    </div>
  );
};

LovablePhaseSection.propTypes = {
  id: PropTypes.string,
  phaseCode: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default LovablePhaseSection;
